import Swiper from 'swiper/bundle';

jQuery(document).ready(function ($) {
  new Swiper('.eet-testimonial__slider', {
    direction: 'horizontal',
    loop: true,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    spaceBetween: 0,
    pagination: {
      el: '.eet-testimonial__pagination',
    },
  });
});